module.exports = __webpack_public_path__ + "bdb9a8f399af0d42e397e95ce9db56e1.jpeg";